"use client";

import CountryFlag from "@/app/(main)/components/CountryFlag";
import styles from "./destination-filter-widget.module.css";

export interface DestinationFilterOption {
  /** Empty string is reserved for the "all" row. */
  id: string;
  label: string;
}

interface DestinationFilterWidgetProps {
  title: string;
  options: DestinationFilterOption[];
  /** Empty string when nothing is filtered. */
  selectedId: string;
  onSelect: (id: string) => void;
  /** Builds the real href for an option, so the list works without JS. */
  hrefFor: (option: DestinationFilterOption) => string;
  allLabel?: string;
}

function PinIcon({ alt }: { alt: string }) {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      width="25"
      src="/main/img/theme-img/pin-mark.svg"
      alt={alt}
      style={{ marginRight: 6, verticalAlign: "middle" }}
    />
  );
}

export default function DestinationFilterWidget({
  title,
  options,
  selectedId,
  onSelect,
  hrefFor,
  allLabel = "All Destinations",
}: DestinationFilterWidgetProps) {
  const rows: DestinationFilterOption[] = [
    { id: "", label: allLabel },
    ...options,
  ];

  return (
    <div className={`widget widget_categories ${styles.widget}`}>
      <h3 className="widget_title">{title}</h3>
      <ul className={styles.list}>
        {rows.map((option) => {
          const selected = option.id === selectedId;
          return (
            <li key={option.id || "all"}>
              <a
                href={hrefFor(option)}
                onClick={(e) => {
                  e.preventDefault();
                  onSelect(option.id);
                }}
                className={`pe-0 ${selected ? "text-theme fw-bold" : ""}`}
                title={option.label}
              >
                {option.id ? (
                  <CountryFlag
                    country={option.label}
                    fallback={<PinIcon alt={option.label} />}
                  />
                ) : (
                  <PinIcon alt={allLabel} />
                )}
                {option.label}
                {selected && (
                  <i className="fa fa-check-circle lh-base float-end" />
                )}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
